import React from "react";
import Title from "./common/Title";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  image: {
    width: "100%",
    objectFit: "cover",
  },
}));

export default function MainSection() {
  const classes = useStyles();

  return (
    <>
      <Title
        title="About Us"
        description="In global setting where political leaders are talking about building walls, NaTakallam is building bridges."
      />
      <Grid container justify="space-evenly" alignItems="stretch">
        <Grid item md={5} sm={8} xs={10}>
          <Box mb={5} mx="auto">
            <img
              className={classes.image}
              src="https://via.placeholder.com/200?text=picture"
              alt="About us"
            />
          </Box>
        </Grid>
        <Grid
          item
          md={5}
          sm={8}
          xs={10}
          container
          direction="column"
          justify="center"
        >
          <Grid item>
            <Box mt={5} width="90%" mx="auto">
              <Typography variant="body1" color="primary">
                {text1}
              </Typography>
            </Box>
          </Grid>
          <Grid item>
            <Box mt={5} width="90%" mx="auto">
              <Typography variant="body1" color="primary">
                {text2}
              </Typography>
            </Box>
          </Grid>
          <Grid item>
            <Box mt={5} width="90%" mx="auto">
              <Link href="#" variant="h3">
                Read More
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

const text1 = `
In the summer of 2014 Aline Sara had just completed her masters in
International Affairs at Columbia University and was looking for an
affordable way to practice her Arabic—specifically, her native Lebanese
regional dialect—from New York City. It was also at that time that Syrians,
fleeing the violence from the brutal civil war, were pouring into Lebanon,
where today, roughly 1 out of 4 people are Syrian.
`;
const text2 = `
Like most Syrians outside of the country, and notably the 5 million-plus who
are living in neighboring countries, Syrians in Lebanon cannot easily get
work permits, making their capacity to work and sustain a livelihood
incredibly difficult. The same daily struggle with varying legal realities holds
true for Venezuelans living in Argentina, people from Burundi living in
Europe or the Middle East, or Yemenis displaced inside their own country.
`;
